// StyledLink.js
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(RouterLink)`
  text-decoration: none; // Remove a decoração do texto
  color: inherit; // Herda a cor do texto do elemento pai
  height: 100%;

  &:hover {
    text-decoration: none;
  }
`;

export default StyledLink;
